import { IMAGES } from "@/constants/site";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center justify-center">
      <img
        src={IMAGES.hero}
        alt="Resort The Forest — cottage exterior surrounded by gardens and tall trees"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/45" />

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto py-32">
        <p className="reveal text-xs md:text-sm uppercase tracking-[0.35em] font-semibold text-[#C5A880]" style={{ animationDelay: "0.1s" }}>
          A Forest Retreat
        </p>
        <h1
          data-testid="hero-title"
          className="reveal font-serif-display font-light text-5xl md:text-6xl lg:text-7xl tracking-tight text-[#FDFBF7] mt-6 leading-[1.05]"
          style={{ animationDelay: "0.25s" }}
        >
          Find Your Peace
          <br />
          in the Wilderness.
        </h1>
        <p
          data-testid="hero-subtitle"
          className="reveal text-base md:text-lg text-[#FDFBF7]/85 leading-relaxed mt-8 max-w-xl mx-auto"
          style={{ animationDelay: "0.4s" }}
        >
          A refined forest retreat where stunning views, honest value and personal hospitality meet — for families, couples and gatherings alike.
        </p>
        <div className="reveal mt-12 flex flex-col sm:flex-row items-center justify-center gap-4" style={{ animationDelay: "0.55s" }}>
          <a
            href="#reserve"
            data-testid="hero-book-cta"
            className="bg-[#C5A880] text-[#0B3B39] text-xs uppercase tracking-[0.25em] font-bold px-10 py-4 rounded-sm hover:bg-[#b39771] transition-colors duration-300"
          >
            Reserve Your Stay
          </a>
          <a
            href="#stays"
            data-testid="hero-explore-cta"
            className="border border-[#FDFBF7]/60 text-[#FDFBF7] text-xs uppercase tracking-[0.25em] font-semibold px-10 py-4 rounded-sm hover:bg-[#FDFBF7]/10 transition-colors duration-300"
          >
            Explore Stays
          </a>
        </div>
      </div>
    </section>
  );
};
